<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <label for="form-organization-gendir" class="control-label">{{ inputLabel }}</label>
    <input
      type="text"
      class="form-control"
      id="form-organization-gendir"
      :disabled="disabled"
      v-model="inputValue"
      @input="emit($event)"
      @change="emit($event)"
      @blur="emit($event)"
    />
    <a v-if="!isCheck && showPrevValue"
       @click="revertAddress"
       class="transport-owner-helpers">
      {{ prevValue }}
    </a>
    <span v-if="isCheck && showPrevValue"
          class="transport-owner-helpers not-link">
      {{ prevValue }}
    </span>
    <error-help-block :has-errors="hasInputErrors" :current-error="actualErrorMessage"/>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import organizationSectionMixin from '../../../../mixins/application-form/organizationSectionMixin'
import organizationInputMixin from '../../../../mixins/application-form/organizationInputMixin'

export default {
  name: 'OrganizationManagerNameInput',
  mixins: [
    applicationInputMixin,
    applicationFormMixin,
    organizationSectionMixin,
    organizationInputMixin
  ],

  props: {
    inputLabel: {
      default: 'Фамилия, имя, отчество руководителя'
    },

    inputName: {
      default: 'director_name'
    },

    prevValue: {
      default: null
    }
  },

  computed: {
    showPrevValue () {
      return this.prevValue && this.prevValue.toLowerCase() !== this.inputValue.toLowerCase()
    }
  },

  methods: {
    revertAddress () {
      this.$emit('input', this.prevValue)
    }
  }
}
</script>
